module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9pHs6"))).then(() => parcelRequire('hEqeo'));